var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenCapture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 155744"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 155741"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.22222 13.3333H0V17.7778C0 19 1 20 2.22222 20H6.66667V17.7778H2.22222V13.3333ZM2.22222 2.22222H6.66667V0H2.22222C1 0 0 1 0 2.22222V6.66667H2.22222V2.22222ZM17.7778 0H13.3333V2.22222H17.7778V6.66667H20V2.22222C20 1 19 0 17.7778 0ZM17.7778 17.7778H13.3333V20H17.7778C19 20 20 19 20 17.7778V13.3333H17.7778V17.7778Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.66699 9.99984C6.66699 8.15539 8.15588 6.6665 10.0003 6.6665C11.8448 6.6665 13.3337 8.15539 13.3337 9.99984C13.3337 11.8443 11.8448 13.3332 10.0003 13.3332C8.15588 13.3332 6.66699 11.8443 6.66699 9.99984Z",
    fill: "#F2484B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenCapture);
export default __webpack_public_path__ + "static/media/screen-capture.951a6eecfc3ece2944e0aed5279b11b7.svg";
export { ForwardRef as ReactComponent };